// ─────────────────────────────────────────────────────────────
// BANNIÈRE HORS-LIGNE — s'affiche quand la connexion est coupée
// Les données restent consultables (cache Firestore) et les
// écritures sont synchronisées automatiquement au retour du réseau.
// ─────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";

export default function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [justBack, setJustBack] = useState(false);

  useEffect(() => {
    const goOffline = () => { setOnline(false); setJustBack(false); };
    const goOnline = () => {
      setOnline(true);
      setJustBack(true);
      setTimeout(() => setJustBack(false), 3500);
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (online && !justBack) return null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: online ? "#e8f5e0" : "#8a4c00",
      color: online ? "#2d6a0a" : "white",
      textAlign: "center", padding: "7px 12px",
      fontSize: 12.5, fontWeight: 600, fontFamily: "'Barlow', sans-serif",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    }}>
      {online
        ? "✓ Connexion rétablie — synchronisation en cours"
        : "📴 Mode hors-ligne — vos données sont consultables, les modifications seront synchronisées au retour du réseau"}
    </div>
  );
}
